export default (): string => {
  const html = document.querySelector('html') as HTMLElement;
  return html.dataset.lifferyVersion as string;
};
